export default "__VITE_ASSET__BuydIRO9__"